module.exports = __webpack_public_path__ + "static/assets/1c222381b193c078893d5e3e473956b0.svg";